module.exports = __webpack_public_path__ + "img/hands-holding-diamond.7d269ffe.svg";